import React from 'react';
import { cn } from '../../utils/cn';
export interface RadioGroupProps {
  label?: string;
  name: string;
  options: {
    label: string;
    value: string;
  }[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  inline?: boolean;
}
export function RadioGroup({
  label,
  name,
  options,
  value,
  onChange,
  className,
  inline = false
}: RadioGroupProps) {
  return <div className={cn('w-full', className)} data-id="element-331">
      {label && <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" data-id="element-332">
          {label}
        </label>}
      <div className={cn('flex', inline ? 'flex-row space-x-4' : 'flex-col space-y-2')} data-id="element-333">
        {options.map(opt => <label key={opt.value} className="flex items-center space-x-2 cursor-pointer group" data-id="element-334">
            <input type="radio" name={name} value={opt.value} checked={value === opt.value} onChange={e => onChange(e.target.value)} className="h-4 w-4 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-indigo-600 dark:text-indigo-500 focus:ring-indigo-500 dark:focus:ring-indigo-400 transition-colors" data-id="element-335" />
            <span className="text-sm text-slate-700 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-slate-100" data-id="element-336">
              {opt.label}
            </span>
          </label>)}
      </div>
    </div>;
}